import React, { useState, useEffect } from "react";
import { Card, Col, Row, Button, Spinner, Modal, Form, InputGroup } from "react-bootstrap";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import paginationFactory from "react-bootstrap-table2-paginator";
import * as Paginator from "react-bootstrap-table2-paginator";
import filterFactory from "react-bootstrap-table2-filter";
import { productService } from "../../../Service/AllSalestoolAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import swal from "sweetalert";

const Draft = () => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState('QUOTES'); // 'QUOTES' or 'BOM'
  const [bomComponents, setBomComponents] = useState([]);
  const [bomLoading, setBomLoading] = useState(false);
  const [selectedQuoteId, setSelectedQuoteId] = useState(null);
  const [isBomEditable, setIsBomEditable] = useState(false);

  const [showQueryModal, setShowQueryModal] = useState(false);
  const [queryData, setQueryData] = useState({ query: "", queryAsignTo: "" });
  const [queryQuoteId, setQueryQuoteId] = useState(null);
  const [viewOnlyHistory, setViewOnlyHistory] = useState(false);

  const [showRespondModal, setShowRespondModal] = useState(false);
  const [respondData, setRespondData] = useState({ response: "" });
  const [respondQueryId, setRespondQueryId] = useState("");
  const [queryHistory, setQueryHistory] = useState([]);
  const [isHistoryLoading, setIsHistoryLoading] = useState(false);

  const chatEndRef = React.useRef(null);
  React.useEffect(() => {
    if (showQueryModal || showRespondModal) {
      setTimeout(() => {
        if (chatEndRef.current) {
          chatEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [queryHistory, showQueryModal, showRespondModal]);

  const [approvalQuoteId, setApprovalQuoteId] = useState(null);
  const [selectedQuoteDetails, setSelectedQuoteDetails] = useState(null);
  const [approvalQuoteStatus, setApprovalQuoteStatus] = useState("");
  const [approvalData, setApprovalData] = useState({
    targetPrice: "",
    winProbability: "",
    bomReadiness: "",
    newCertifications: "",
    additionalCustomization: "",
    leadTime: "",
    inventoryAvailability: "",
    pl: "",
    ccPlan: "",
    resourceAvailability: "",
    additionalInputs: "",
    approvalTerms: ""
  });

  const currentUserRole = sessionStorage.getItem("role") || "";

  const getAssigneeOptions = () => {
    const roleUpper = currentUserRole.toUpperCase();

    if (roleUpper === "RND_REVIEWER") {
      return [{ value: "Sales_person", label: "Sales Team" }];
    } else if (roleUpper === "PROCUREMENT_REVIEWER") {
      return [
        { value: "Sales_person", label: "Sales Team" },
        { value: "RND_REVIEWER", label: "R&D Team" }
      ];
    } else if (roleUpper === "FINANCE_REVIEWER") {
      return [
        { value: "Sales_person", label: "Sales Team" },
        { value: "RND_REVIEWER", label: "R&D Team" },
        { value: "PROCUREMENT_REVIEWER", label: "Procurement Team" }
      ];
    } else if (roleUpper === "PRODUCTION_REVIEWER") {
      return [
        { value: "Sales_person", label: "Sales Team" },
        { value: "RND_REVIEWER", label: "R&D Team" },
        { value: "PROCUREMENT_REVIEWER", label: "Procurement Team" },
        { value: "FINANCE_REVIEWER", label: "Finance Team" }
      ];
    } else if (roleUpper === "SLT_REVIEWER") {
      return [
        { value: "Sales_person", label: "Sales Team" },
        { value: "RND_REVIEWER", label: "R&D Team" },
        { value: "PROCUREMENT_REVIEWER", label: "Procurement Team" },
        { value: "FINANCE_REVIEWER", label: "Finance Team" },
        { value: "PRODUCTION_REVIEWER", label: "Production Team" }
      ];
    }
    return [];
  };

  const handleQuerySubmit = async () => {
    if (queryData.query.trim() === "" || queryData.queryAsignTo === "") {
      swal("Warning", "Please enter query text and select an assignee.", "warning");
      return;
    }

    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const time = now.toLocaleTimeString();

    const queryPayload = {
      quoteId: queryQuoteId,
      query: queryData.query,
      queryAssignTo: queryData.queryAsignTo
    };

    try {
      await productService.submitQuery(queryPayload);

      console.log("Submitting query for quote ID:", queryQuoteId, queryPayload);
      swal("Success", "Query raised successfully!", "success");

      // Clear form to allow further queries
      setQueryData({ query: "", queryAsignTo: "" });
      setViewOnlyHistory(true);
      fetchQueryHistory(queryQuoteId);
      fetchQuotes();
    } catch (error) {
      console.error("Error submitting query", error);
      swal("Error", "Failed to submit query", "error");
    }
  };

  const fetchQueryHistory = async (quoteId) => {
    setIsHistoryLoading(true);
    try {
      const history = await productService.getQueryHistory(quoteId);
      const historyArray = Array.isArray(history) ? history : [];
      setQueryHistory(historyArray);

      // Since the main table doesn't have query details on load, we check here
      let expectedRole = currentUserRole;
      if (expectedRole.toUpperCase().includes("SALES")) {
        expectedRole = "Sales_person";
      }

      const pendingQuery = historyArray.find(q =>
        q.queryStatus === "OPEN" &&
        q.queryAssignTo &&
        q.queryAssignTo.toLowerCase() === expectedRole.toLowerCase()
      );

      if (pendingQuery) {
        setRespondQueryId(pendingQuery.id || pendingQuery.queryId);
        setShowQueryModal(false);
        setShowRespondModal(true);

        // Dynamically update the table row to switch the button from Query to Respond
        setEntries(prevEntries => prevEntries.map(entry => {
          if (entry.quoteId === quoteId || entry.id === quoteId) {
            return {
              ...entry,
              queryId: pendingQuery.id || pendingQuery.queryId,
              action: ` Edit / Respond / Submit ${currentUserRole.toUpperCase().includes("SALES") ? ' / Delete' : ''}`
            };
          }
          return entry;
        }));
      }

    } catch (error) {
      console.error("Error fetching query history:", error);
      setQueryHistory([]);
    } finally {
      setIsHistoryLoading(false);
    }
  };

  const handleRespondSubmit = async () => {
    if (respondData.response.trim() === "") {
      swal("Warning", "Please enter your response.", "warning");
      return;
    }
    const payload = {
      queryId: respondQueryId || 9,
      queryResponse: respondData.response
    };
    try {
      await productService.respondToQuery(payload);
      swal("Success", "Response submitted successfully!", "success");
      setRespondData({ response: "" });
      fetchQueryHistory(queryQuoteId);
      fetchQuotes();
      setShowRespondModal(false);
    } catch (error) {
      console.error("Error responding to query:", error);
      swal("Error", "Failed to submit response", "error");
    }
  };

  const handleDeleteQuote = (quoteId) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this quote!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          await productService.deleteQuote(quoteId);

          swal("Your quote has been deleted!", {
            icon: "success",
          });

          fetchQuotes();
        } catch (error) {
          console.error("Error deleting quote", error);
          swal("Error", "Failed to delete quote", "error");
        }
      }
    });
  };

  const handleSubmitForApproval = async (quoteId, status = "") => {
    setApprovalQuoteId(quoteId);
    setApprovalQuoteStatus(status);
    setViewMode('APPROVAL');

    const quoteDetails = entries.find(e => (e.quoteId || e.id) === quoteId);
    setSelectedQuoteDetails(quoteDetails || null);

    // Set initial empty state while fetching
    setApprovalData({
      targetPrice: "",
      winProbability: "",
      bomReadiness: "",
      newCertifications: "",
      additionalCustomization: "",
      leadTime: "",
      inventoryAvailability: "",
      pl: "",
      ccPlan: "",
      resourceAvailability: "",
      additionalInputs: "",
      approvalTerms: ""
    });

    try {
      const details = await productService.getApprovalDetails(quoteId);
      if (details) {
        setApprovalData(prev => ({
          ...prev,
          targetPrice: details.Sales?.TARGET_PRICE || "",
          winProbability: details.Sales?.WIN_PROBABILITY || "",
          bomReadiness: details.RND?.BOM_READINESS || details["R&D"]?.BOM_READINESS || details["R&D / Engineering"]?.BOM_READINESS || "",
          newCertifications: details.RND?.NEW_CERTIFICATIONS || details["R&D"]?.NEW_CERTIFICATIONS || details["R&D / Engineering"]?.NEW_CERTIFICATIONS || "",
          additionalCustomization: details.RND?.ADDITIONAL_CUSTOMIZATION || details["R&D"]?.ADDITIONAL_CUSTOMIZATION || details["R&D / Engineering"]?.ADDITIONAL_CUSTOMIZATION || "",
          leadTime: details.Procurement?.LEAD_TIME || "",
          inventoryAvailability: details.Procurement?.INVENTORY_AVAILABILITY || "",
          pl: details.Finance?.PL || "",
          ccPlan: details.Finance?.CC_PLAN || "",
          resourceAvailability: details.Production?.RESOURCE_AVAILABILITY || "",
          additionalInputs: details.Production?.ADDITIONAL_INPUTS || "",
          approvalTerms: details.SLT?.APPROVAL_TERMS_CONDITIONS || details["Senior Management"]?.APPROVAL_TERMS_CONDITIONS || ""
        }));
      }
    } catch (error) {
      console.error("Failed to fetch approval details", error);
    }
  };

  const isApprovalFormValid = () => {
    const roleUpper = currentUserRole.toUpperCase();
    if (roleUpper.includes("SALES")) {
      return approvalData.targetPrice.trim() !== "" && approvalData.winProbability.trim() !== "";
    } else if (currentUserRole === "RND_REVIEWER") {
      return approvalData.bomReadiness.trim() !== "" && approvalData.newCertifications.trim() !== "" && approvalData.additionalCustomization.trim() !== "";
    } else if (currentUserRole === "PROCUREMENT_REVIEWER") {
      return approvalData.leadTime.trim() !== "" && approvalData.inventoryAvailability.trim() !== "";
    } else if (currentUserRole === "FINANCE_REVIEWER") {
      return approvalData.pl.trim() !== "" && approvalData.ccPlan.trim() !== "";
    } else if (currentUserRole === "PRODUCTION_REVIEWER") {
      return approvalData.resourceAvailability.trim() !== "" && approvalData.additionalInputs.trim() !== "";
    } else if (currentUserRole === "SLT_REVIEWER") {
      return approvalData.approvalTerms.trim() !== "";
    }
    return false;
  };

  const confirmSubmitForApproval = async () => {
    swal({
      text: "Do you want to submit?",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then(async (willSubmit) => {
      if (willSubmit) {
        try {
          let fields = {};
          const roleUpper = currentUserRole.toUpperCase();

          if (roleUpper.includes("SALES")) {
            fields = {
              TARGET_PRICE: approvalData.targetPrice,
              WIN_PROBABILITY: approvalData.winProbability
            };
          } else if (currentUserRole === "RND_REVIEWER") {
            fields = {
              BOM_READINESS: approvalData.bomReadiness,
              NEW_CERTIFICATIONS: approvalData.newCertifications,
              ADDITIONAL_CUSTOMIZATION: approvalData.additionalCustomization
            };
          } else if (currentUserRole === "PROCUREMENT_REVIEWER") {
            fields = {
              LEAD_TIME: approvalData.leadTime,
              INVENTORY_AVAILABILITY: approvalData.inventoryAvailability
            };
          } else if (currentUserRole === "FINANCE_REVIEWER") {
            fields = {
              PL: approvalData.pl,
              CC_PLAN: approvalData.ccPlan
            };
          } else if (currentUserRole === "PRODUCTION_REVIEWER") {
            fields = {
              RESOURCE_AVAILABILITY: approvalData.resourceAvailability,
              ADDITIONAL_INPUTS: approvalData.additionalInputs
            };
          } else if (currentUserRole === "SLT_REVIEWER") {
            fields = {
              APPROVAL_TERMS_CONDITIONS: approvalData.approvalTerms
            };
          }

          const payload = {
            quoteId: approvalQuoteId,
            pkUserId: sessionStorage.getItem("pkUserId") || "",
            role: currentUserRole,
            fields: fields
          };

          await productService.submitForApproval(payload);
          swal("Success", "Quote submitted successfully!", "success");
          setViewMode('QUOTES');
          fetchQuotes();
        } catch (error) {
          console.error("Error submitting quote", error);
          swal("Error", "Failed to submit quote for approval", "error");
        }
      }
    });
  };

  const confirmSLTAction = async (actionType) => {
    swal({
      text: `Do you want to ${actionType}?`,
      icon: "warning",
      buttons: true,
      dangerMode: actionType === "decline",
    }).then(async (willSubmit) => {
      if (willSubmit) {
        try {
          const payload = {
            quoteId: approvalQuoteId,
            pkUserId: sessionStorage.getItem("pkUserId") || "",
            role: currentUserRole,
            action: actionType === 'approve' ? 'APPROVED' : 'DECLINED',
            fields: {
              APPROVAL_TERMS_CONDITIONS: approvalData.approvalTerms
            }
          };

          await productService.submitForApproval(payload);
          swal("Success", `Quote ${actionType}d successfully!`, "success");
          setViewMode('QUOTES');
          fetchQuotes();
        } catch (error) {
          console.error(`Error ${actionType}ing quote`, error);
          swal("Error", `Failed to ${actionType} quote`, "error");
        }
      }
    });
  };

  const handleQuoteIdClick = async (quoteId, isEditable = false) => {
    if (!quoteId) return;

    try {
      setViewMode('BOM');
      setBomLoading(true);
      setSelectedQuoteId(quoteId);
      setIsBomEditable(isEditable);

      const data = await productService.getBomComponentsByQuoteId(quoteId);
      const fetched = Array.isArray(data) ? data : [];

      setBomComponents(
        fetched.map((item, idx) => ({
          ...item,
          id: item.id || idx
        }))
      );
    } catch (error) {
      console.error("Error fetching BOM components:", error);
      setBomComponents([]);
    } finally {
      setBomLoading(false);
    }
  };

  const bomColumns = [
    {
      dataField: "piItemCodePart",
      text: "Item Code",
      headerAlign: "left",
      attrs: isBomEditable ? { title: "Click to edit bom components" } : {},
      style: { fontSize: '0.7rem' },
      headerStyle: { fontSize: '0.6rem', position: "sticky", top: 0, zIndex: 5, background: "#457756", color: "white" }
    },
    {
      dataField: "piDescription",
      text: "Description",
      headerAlign: "left",
      attrs: isBomEditable ? { title: "Click to edit bom components " } : {},
      style: { fontSize: '0.7rem' },
      headerStyle: { fontSize: '0.6rem', position: "sticky", top: 0, zIndex: 5, background: "#457756", color: "white" }
    },
    {
      dataField: "quantity.value",
      text: bomComponents?.[0]?.quantity?.productname || "Quantity",
      headerAlign: "left",
      formatter: (cell, row) => row.quantity?.value ?? "",
      attrs: isBomEditable ? { title: "Click to edit bom components " } : {},
      style: { fontSize: '0.7rem' },
      headerStyle: { fontSize: '0.6rem', position: "sticky", top: 0, zIndex: 5, background: "#457756", color: "white" }
    },
    {
      dataField: "partCategory",
      text: "Category",
      headerAlign: "left",
      attrs: isBomEditable ? { title: "Click to edit bom components " } : {},
      style: { fontSize: '0.7rem' },
      headerStyle: { fontSize: '0.6rem', position: "sticky", top: 0, zIndex: 5, background: "#457756", color: "white" }
    },
    {
      dataField: "vertical",
      text: "Vertical",
      headerAlign: "left",
      attrs: isBomEditable ? { title: "Click to edit bom components" } : {},
      style: { fontSize: '0.7rem' },
      headerStyle: { fontSize: '0.6rem', position: "sticky", top: 0, zIndex: 5, background: "#457756", color: "white" }
    },
    {
      dataField: "type",
      text: "Type",
      headerAlign: "left",
      attrs: isBomEditable ? { title: "Click to edit bom components" } : {},
      style: { fontSize: '0.7rem' },
      headerStyle: { fontSize: '0.6rem', position: "sticky", top: 0, zIndex: 5, background: "#457756", color: "white" }
    },

    {
      dataField: "supplier",
      text: "Supplier",
      headerAlign: "left",
      attrs: isBomEditable ? { title: "Click to edit bom components" } : {},
      style: { fontSize: '0.7rem' },
      headerStyle: { fontSize: '0.6rem', position: "sticky", top: 0, zIndex: 5, background: "#457756", color: "white" }
    },


  ];


  useEffect(() => {
    fetchQuotes();
  }, []);

  const fetchQuotes = async () => {
    try {
      setLoading(true);
      console.log("Fetching quotes from backend (getAllQuoteList)...");
      const data = await productService.getAllQuoteList();
      console.log("Raw quote list response:", data);

      const list = Array.isArray(data) ? data : [];

      let expectedRole = currentUserRole;
      const isSales = currentUserRole.toUpperCase().includes("SALES");
      if (isSales) {
        expectedRole = "Sales_person";
      }

      const formattedList = await Promise.all(list.map(async (item, index) => {
        const terms = item.commercialTerms || {};
        const quoteIdStr = item.quoteId || item.id || item._id || "";

        let btnAction = "Query";
        let showQueryBtn = true;
        let isAssignedToUser = false;
        let isWaitingForResponse = false;
        let hasEverRaisedQuery = false;
        let activeQueryId = item.queryId || "";

        if (quoteIdStr) {
          try {
            const history = await productService.getQueryHistory(quoteIdStr);
            const historyArray = Array.isArray(history) ? history : [];
            const pendingQuery = historyArray.find(q =>
              q.queryStatus === "OPEN" &&
              q.queryAssignTo &&
              q.queryAssignTo.toLowerCase() === expectedRole.toLowerCase()
            );
            if (pendingQuery) {
              isAssignedToUser = true;
              activeQueryId = pendingQuery.id || pendingQuery.queryId || activeQueryId;
            }

            const waitingForResponseQuery = historyArray.find(q =>
              q.queryStatus === "OPEN" &&
              (q.queryRaisedBy || q.submittedBy || "").toLowerCase() === expectedRole.toLowerCase()
            );
            if (waitingForResponseQuery) {
              isWaitingForResponse = true;
            }

            const anyQueryRaisedByUser = historyArray.find(q =>
              (q.queryRaisedBy || q.submittedBy || "").toLowerCase() === expectedRole.toLowerCase()
            );
            if (anyQueryRaisedByUser) {
              hasEverRaisedQuery = true;
            }
          } catch (e) {
            console.error("Error fetching history for quote on load:", quoteIdStr, e);
          }
        }

        if (isSales) {
          // For Salesperson: ONLY show 'Respond' button when they have a reply pending. Otherwise show button to view history.
          if (isAssignedToUser) {
            btnAction = "Respond";
          } else {
            showQueryBtn = true;
          }
        } else {
          // For other users: show 'Respond' if assigned to them, otherwise 'Query'
          if (isAssignedToUser) {
            btnAction = "Respond";
          }
        }

        return {
          id: item.id || item._id || index + 1,
          createdDate: item.createdDate || "",
          product: item.product || "",
          subProduct: item.subProduct || "",
          quoteId: item.quoteId || item.id || item._id || "",
          configuration: item.configurationType || "",
          type: item.type || "",
          modelNumber: item.modelNumber || "",
          duType: item.duType || "",
          flowRate: item.flowRate || "",
          vrs: item.vrs || "",
          duConfiguration: item.duConfiguration || item.configurationType || "",
          description: item.description || "",
          customerName: item.customerName || terms.customerName || "",
          deliveryTerms: item.deliveryTerms || terms.deliveryTerms || "",
          deliveryTimeline: item.deliveryTimeline || terms.deliveryTimeline || "",
          expectedPODate: item.expectedPODate || terms.expectedPODate || "",
          paymentTerms: item.paymentTerms || terms.paymentTerms || "",
          country: item.country || terms.country || "",
          createdBy: item.createdBy || "",
          quantity: terms.quantity || "",
          currency: terms.currency || "",
          quoteValue: item.quoteValue || "",
          // remarks: terms.remarks || "",
          certifications: terms.certifications || item.certifications || "",
          department: item.department || "",
          status: item.status || "Draft",
          approvalStage: item.approvalStage || "",
          queryId: activeQueryId,
          isWaitingForResponse: isWaitingForResponse,
          hasEverRaisedQuery: hasEverRaisedQuery,
          uploadedFile: item.uploadedFile || item.uploadFile || terms?.uploadedFile || terms?.uploadFile || "",
          action: showQueryBtn ? ` Edit / ${btnAction} / Submit ${isSales ? ' / Delete' : ''}` : ` Edit / Submit ${isSales ? ' / Delete' : ''}`
        };
      }));
      console.log("Formatted list for table:", formattedList);

      // Sort to show latest data on top
      formattedList.sort((a, b) => {
        const dateA = new Date(a.createdDate).getTime();
        const dateB = new Date(b.createdDate).getTime();
        if (isNaN(dateA) && isNaN(dateB)) return 0;
        if (isNaN(dateA)) return 1;
        if (isNaN(dateB)) return -1;
        return dateB - dateA;
      });

      setEntries(formattedList);
    } catch (error) {
      console.error("Error fetching quotes:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      dataField: "quoteId",
      text: "Quote ID",
      headerAlign: "left",
      style: { position: 'sticky', left: 0, backgroundColor: 'var(--sticky-bg, inherit)', zIndex: 1, width: '80px', minWidth: '80px', maxWidth: '80px' },
      headerStyle: { position: 'sticky', left: 0, backgroundColor: 'var(--sticky-bg, inherit)', zIndex: 2, width: '80px', minWidth: '80px', maxWidth: '80px' },
      formatter: (cell) => (
        <span
          style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
          onClick={() => handleQuoteIdClick(cell)}
        >
          {cell}
        </span>
      )
    },
    { 
      dataField: "product", 
      text: "Product", 
      headerAlign: "left",
      style: { position: 'sticky', left: '80px', backgroundColor: 'var(--sticky-bg, inherit)', zIndex: 1, width: '100px', minWidth: '100px', maxWidth: '100px' },
      headerStyle: { position: 'sticky', left: '80px', backgroundColor: 'var(--sticky-bg, inherit)', zIndex: 2, width: '100px', minWidth: '100px', maxWidth: '100px' }
    },
    { 
      dataField: "subProduct", 
      text: "Sub Product", 
      headerAlign: "left",
      style: { position: 'sticky', left: '180px', backgroundColor: 'var(--sticky-bg, inherit)', zIndex: 1, width: '100px', minWidth: '100px', maxWidth: '100px' },
      headerStyle: { position: 'sticky', left: '180px', backgroundColor: 'var(--sticky-bg, inherit)', zIndex: 2, width: '100px', minWidth: '100px', maxWidth: '100px' }
    },
    {
      dataField: "action",
      text: "Action",
      headerAlign: "left",
      style: { position: 'sticky', left: '280px', backgroundColor: 'var(--sticky-bg, inherit)', zIndex: 1, minWidth: 'max-content' },
      headerStyle: { position: 'sticky', left: '280px', backgroundColor: 'var(--sticky-bg, inherit)', zIndex: 2, minWidth: 'max-content' },
      formatter: (cell, row) => {
        if (!cell) return null;
        const actions = cell.split(" / ");

        const roleUpper = currentUserRole.toUpperCase();
        const stage = (row.approvalStage || row.status || "").toLowerCase();
        const currentStatus = (row.status || "").toLowerCase();
        let isNotTheirTurn = false;

        if (roleUpper.includes("SALES")) {
          if (currentStatus !== "draft") {
            isNotTheirTurn = true;
          }
        } else if (roleUpper === "RND_REVIEWER") {
          if (stage !== "submitted to r&d / engineering" && stage !== "submitted to r&d") {
            isNotTheirTurn = true;
          }
        } else if (roleUpper === "PROCUREMENT_REVIEWER") {
          if (stage !== "submitted to procurement") {
            isNotTheirTurn = true;
          }
        } else if (roleUpper === "FINANCE_REVIEWER") {
          if (stage !== "submitted to finance") {
            isNotTheirTurn = true;
          }
        } else if (roleUpper === "PRODUCTION_REVIEWER") {
          if (stage !== "submitted to production") {
            isNotTheirTurn = true;
          }
        } else if (roleUpper === "SLT_REVIEWER") {
          if (stage !== "submitted to senior management" && stage !== "submitted to slt") {
            isNotTheirTurn = true;
          }
          if (currentStatus === "approved" || currentStatus === "declined") {
            isNotTheirTurn = true;
          }
        }

        return (
          <div style={{ display: 'flex', flexDirection: 'row', gap: '6px', flexWrap: 'wrap', minWidth: 'max-content' }}>
            {actions.map((action, idx) => {
              let variant = "secondary";
              let isDisabled = false;
              let actionLabel = action.trim();
              if (action.trim().toLowerCase() === "delete") variant = "danger";
              else if (action.trim().toLowerCase().includes("submit")) {
                isDisabled = isNotTheirTurn || row.isWaitingForResponse;
                variant = isDisabled ? "success" : "primary";
              }
              else if (action.trim().toLowerCase() === "edit") {
                if (roleUpper !== "RND_REVIEWER" && roleUpper !== "PROCUREMENT_REVIEWER") {
                  return null;
                }
                variant = "primary";
              }
              else if (action.trim().toLowerCase() === "query") {
                const isSalesUser = currentUserRole.toUpperCase().includes("SALES");
                if (row.isWaitingForResponse) {
                  variant = "warning";
                  actionLabel = "Awaiting Reply";
                } else if (isNotTheirTurn || isSalesUser) {
                  variant = "info";
                  actionLabel = "View Response";
                } else {
                  variant = "danger";
                  actionLabel = "Raise A Query";
                }
              }
              else if (action.trim().toLowerCase() === "respond") {
                variant = "warning";
                actionLabel = "Reply to Query";
              }

              return (
                <Button
                  key={idx}
                  variant={variant}
                  size="sm"
                  disabled={isDisabled}
                  onClick={() => {
                    const isSalesUser = currentUserRole.toUpperCase().includes("SALES");
                    if (action.trim().toLowerCase() === "query") {
                      setQueryQuoteId(row.quoteId || row.id);
                      setQueryData({ query: "", queryAsignTo: "" });
                      fetchQueryHistory(row.quoteId || row.id);
                      setViewOnlyHistory(isNotTheirTurn || isSalesUser || row.isWaitingForResponse);
                      setShowQueryModal(true);
                    } else if (action.trim().toLowerCase() === "respond") {
                      setQueryQuoteId(row.quoteId || row.id);
                      setRespondQueryId(row.queryId || 9);
                      setRespondData({ response: "" });
                      fetchQueryHistory(row.quoteId || row.id);
                      setShowRespondModal(true);
                    } else if (action.trim().toLowerCase() === "delete") {
                      handleDeleteQuote(row.quoteId || row.id);
                    } else if (action.trim().toLowerCase() === "edit") {
                      handleQuoteIdClick(row.quoteId || row.id, true);
                    } else if (action.trim().toLowerCase().includes("submit")) {
                      handleSubmitForApproval(row.quoteId || row.id, row.status);
                    }
                  }}
                >
                  {actionLabel}
                </Button>
              );
            })}
          </div>
        );
      }
    },
    { dataField: "configuration", text: "Configuration", headerAlign: "left" },
    {
      dataField: "createdDate",
      text: "Date",
      headerAlign: "left",
      formatter: (cell) => cell ? cell.toString().split('T')[0].split(' ')[0] : ""
    },
    // { dataField: "description", text: "Description", headerAlign: "left" },
    {
      dataField: "status",
      text: "Status",
      headerAlign: "left",
      formatter: (cell, row) => {
        if (cell && (cell.toLowerCase() === "approved" || cell.toLowerCase() === "declined")) {
          return (
            <span
              style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
              onClick={() => handleSubmitForApproval(row.quoteId || row.id, row.status)}
            >
              {cell}
            </span>
          );
        }
        return cell;
      }
    },
    { dataField: "customerName", text: "Customer Name", headerAlign: "left" },
    { dataField: "deliveryTerms", text: "Delivery Terms", headerAlign: "left" },
    { dataField: "deliveryTimeline", text: "Delivery Timeline", headerAlign: "left" },
    { dataField: "expectedPODate", text: "Expected PO Date", headerAlign: "left" },
    { dataField: "paymentTerms", text: "Payment Terms", headerAlign: "left" },
    { dataField: "country", text: "Country", headerAlign: "left" },
    { dataField: "createdBy", text: "Created by", headerAlign: "left" },
    { dataField: "quantity", text: "Quantity", headerAlign: "left" },
    { dataField: "currency", text: "Currency", headerAlign: "left" },
    { dataField: "quoteValue", text: "Quote Value", headerAlign: "left" },
    // { dataField: "remarks", text: "Remarks", headerAlign: "left" },
    { dataField: "certifications", text: "Certifications", headerAlign: "left" },
    { dataField: "department", text: "Department", headerAlign: "left" },
    {
      dataField: "uploadedFile",
      text: "Uploaded File",
      headerAlign: "left",
      formatter: (cell, row) => {
        if (!cell || cell === "" || cell === "-") {
          return (
            <Button variant="outline-primary" size="sm" disabled>
              No File Yet
            </Button>
          );
        }

        const handleDownload = () => {
          try {
            let base64Data = cell;
            let mimeType = "application/octet-stream";
            let extension = "bin";

            if (cell.includes("base64,")) {
               const parts = cell.split("base64,");
               base64Data = parts[1];
               mimeType = parts[0].split(";")[0].replace("data:", "");
               
               if (mimeType.includes("zip")) extension = "zip";
               if (mimeType.includes("pdf")) extension = "pdf";
               if (mimeType.includes("spreadsheetml") || mimeType.includes("excel")) extension = "xlsx";
               if (mimeType === "application/vnd.ms-excel") extension = "xls";
               if (mimeType.includes("wordprocessingml") || mimeType.includes("msword")) extension = "docx";
               if (mimeType === "application/msword") extension = "doc";

               if (mimeType === "@file/zip") {
                 mimeType = "application/zip";
                 extension = "zip";
               }
            } else {
               // Detect based on magic string
               if (cell.startsWith("JVBERi")) {
                 mimeType = "application/pdf";
                 extension = "pdf";
               } else if (cell.startsWith("UEsDBBQ") || cell.startsWith("UEsDBAo")) {
                 mimeType = "application/zip"; 
                 extension = "zip";
                 try {
                   const sample = atob(base64Data.substring(0, 2000));
                   if (sample.includes("xl/")) {
                     mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                     extension = "xlsx";
                   } else if (sample.includes("word/")) {
                     mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
                     extension = "docx";
                   }
                 } catch(e) {}
               } else if (cell.startsWith("0M8R4KGx")) {
                 mimeType = "application/msword";
                 extension = "doc";
                 try {
                   const sample = atob(base64Data.substring(0, 2000));
                   if (sample.includes("Excel") || sample.includes("Workbook")) {
                     mimeType = "application/vnd.ms-excel";
                     extension = "xls";
                 }
                 } catch(e) {}
               }
            }

            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: mimeType });
            
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = `Document_${row.quoteId || 'file'}.${extension}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
          } catch (err) {
            console.error("Error downloading file", err);
            // Fallback
            window.open(cell.startsWith('data:') ? cell : `data:application/octet-stream;base64,${cell}`, "_blank");
          }
        };

        return (
          <Button
            variant="primary"
            size="sm"
            onClick={handleDownload}
          >
            Download
          </Button>
        );
      }
    }
  ];

  const formatRoleName = (role) => {
    if (!role) return 'Unknown';
    const upperRole = role.toUpperCase();
    if (upperRole.includes("SALES")) return "Sales Team";
    if (upperRole === "RND_REVIEWER") return "R&D Team";
    if (upperRole === "PROCUREMENT_REVIEWER") return "Procurement Team";
    if (upperRole === "FINANCE_REVIEWER") return "Finance Team";
    if (upperRole === "PRODUCTION_REVIEWER") return "Production Team";
    if (upperRole === "SLT_REVIEWER") return "SLT";
    return role.replace(/_/g, ' ');
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString; // Fallback if parsing fails

    const options = {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return date.toLocaleString('en-US', options);
  };

  const renderQueryHistory = () => {
    if (isHistoryLoading) {
      return <div className="text-center p-3">Loading history...</div>;
    }
    if (!queryHistory || queryHistory.length === 0) {
      return null;
    }

    const sortedHistory = [...queryHistory].sort((a, b) => {
      const dateA = new Date(a.createdDate || a.date || a.timestamp || 0).getTime();
      const dateB = new Date(b.createdDate || b.date || b.timestamp || 0).getTime();
      // Ascending order (latest at bottom)
      return dateA - dateB;
    });

    return (
      <div className="mb-3">
        <h6 className="text-muted mb-2">Query History</h6>
        <div style={{ maxHeight: '350px', overflowY: 'auto', padding: '15px', borderRadius: '8px', backgroundColor: '#f4f7f6', border: '1px solid #e1e5eb' }}>
          {sortedHistory.map((item, index) => {
            let expectedRole = currentUserRole;
            if (currentUserRole && currentUserRole.toUpperCase().includes("SALES")) {
              expectedRole = "Sales_person";
            }

            const querySender = item.queryRaisedBy || item.submittedBy || "";
            const isMyQuery = querySender.toLowerCase() === expectedRole.toLowerCase();

            const responseSender = item.responseBy || "";
            const isMyResponse = responseSender.toLowerCase() === expectedRole.toLowerCase();

            return (
              <div key={index} className="mb-4">
                {/* Query Bubble */}
                <div className={`d-flex flex-column ${isMyQuery ? 'align-items-end' : 'align-items-start'} mb-2`}>
                  <div className="p-2 px-3 shadow-sm" style={{ backgroundColor: isMyQuery ? '#dcf8c6' : '#ffffff', borderRadius: '12px', borderTopRightRadius: isMyQuery ? '0' : '12px', borderTopLeftRadius: isMyQuery ? '12px' : '0', maxWidth: '85%', border: isMyQuery ? '1px solid #c4e5b3' : '1px solid #e9ecef', position: 'relative' }}>
                    <strong style={{ fontSize: '0.8rem', color: isMyQuery ? '#27ae60' : '#3498db', display: 'block', marginBottom: '4px', borderBottom: isMyQuery ? '1px solid #c4e5b3' : '1px solid #eee', paddingBottom: '4px' }}>
                      📝 Query raised by: {formatRoleName(querySender)}
                    </strong>
                    <p className="mb-1 mt-2 text-dark" style={{ fontSize: '0.9rem', lineHeight: '1.4', wordBreak: 'break-word' }}>
                      {item.query || item.queryText}
                    </p>
                    <div className="text-end mt-1">
                      <span className="text-muted" style={{ fontSize: '0.65rem' }}>
                        {formatDate(item.createdDate || item.date || item.timestamp)}
                      </span>
                    </div>
                  </div>
                  {item.queryAssignTo || item.queryAsignTo ? (
                    <small className={`text-muted mt-1 ${isMyQuery ? 'me-2' : 'ms-2'}`} style={{ fontSize: '0.75rem' }}>
                      Assigned to: <strong>{formatRoleName(item.queryAssignTo || item.queryAsignTo)}</strong>
                    </small>
                  ) : null}
                </div>

                {/* Response Bubble */}
                {item.queryResponse && (
                  <div className={`d-flex flex-column ${isMyResponse ? 'align-items-end' : 'align-items-start'} mt-2`}>
                    <div className="p-2 px-3 shadow-sm" style={{ backgroundColor: isMyResponse ? '#dcf8c6' : '#f0f4f8', borderRadius: '12px', borderTopRightRadius: isMyResponse ? '0' : '12px', borderTopLeftRadius: isMyResponse ? '12px' : '0', maxWidth: '85%', border: isMyResponse ? '1px solid #c4e5b3' : '1px solid #d9e2ec', position: 'relative' }}>
                      <strong style={{ fontSize: '0.8rem', color: isMyResponse ? '#27ae60' : '#8e44ad', display: 'block', marginBottom: '4px', borderBottom: isMyResponse ? '1px solid #c4e5b3' : '1px solid #dce2e8', paddingBottom: '4px' }}>
                        ✅ Reply from: {item.responseBy ? formatRoleName(item.responseBy) : 'Response'}
                      </strong>
                      <p className="mb-1 mt-2 text-dark" style={{ fontSize: '0.9rem', lineHeight: '1.4', wordBreak: 'break-word' }}>
                        {item.queryResponse}
                      </p>
                      <div className="text-end mt-1">
                        <span className="text-muted" style={{ fontSize: '0.65rem' }}>
                          {formatDate(item.responseDate)}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
          <div ref={chatEndRef} />
        </div>
      </div>
    );
  };

  const isApprovedView = approvalQuoteStatus && (approvalQuoteStatus.toLowerCase() === "approved" || approvalQuoteStatus.toLowerCase() === "declined");

  useEffect(() => {
    const handleScroll = (e) => {
      if (e.target.scrollLeft > 0) {
        e.target.classList.add('is-scrolling');
      } else {
        e.target.classList.remove('is-scrolling');
      }
    };
    const wrappers = document.querySelectorAll('.custom-scroll-wrapper');
    wrappers.forEach(w => w.addEventListener('scroll', handleScroll));
    return () => wrappers.forEach(w => w.removeEventListener('scroll', handleScroll));
  });

  return (
    <div className="sales-tool-root">
      <style>{`
        .custom-scroll-wrapper {
          --sticky-bg: inherit;
        }
        .custom-scroll-wrapper.is-scrolling {
          --sticky-bg: #fff;
        }
        /* Add a subtle shadow when scrolling for better separation */
        .custom-scroll-wrapper.is-scrolling td:nth-child(4),
        .custom-scroll-wrapper.is-scrolling th:nth-child(4) {
          box-shadow: 4px 0 6px -2px rgba(0,0,0,0.1);
        }
        /* Reduce column gaps */
        .custom-scroll-wrapper table th,
        .custom-scroll-wrapper table td {
          padding-left: 4px !important;
          padding-right: 4px !important;
        }
      `}</style>
      {viewMode === 'QUOTES' ? (
        <ToolkitProvider
          keyField="id"
          columns={columns}
          data={entries}
        >
          {({ baseProps }) => (
            <Paginator.PaginationProvider
              pagination={paginationFactory({
                custom: true,
                alwaysShowAllBtns: true,
                sizePerPage: 8,
                totalSize: entries.length,
                disablePageTitle: true,
                showTotal: true,
                paginationTotalRenderer: (from, to, size) => (
                  <div>
                    Showing {from} to {to} of {size} entries
                  </div>
                ),
              })}
            >
              {({ paginationProps, paginationTableProps }) => (
                <Card>
                  <Col xs={12} md={6} className="p-3 d-flex align-items-center">
                    <h5 className="head m-0" style={{ fontSize: '1.1rem' }}>Quote Status</h5>
                  </Col>
                  <div className="table-responsive py-2">
                    <BootstrapTable
                      {...baseProps}
                      {...paginationTableProps}
                      bodyClasses="border-0 text-nowrap align-middle"
                      rowClasses="border-bottom"
                      classes="table-flush dataTable-table text-nowrap table-sm mb-4 sales-custom-table"
                      wrapperClasses="table-responsive custom-scroll-wrapper"
                      headerClasses="header-class text-nowrap"
                      hover
                      striped
                      filter={filterFactory()}
                      noDataIndication={() => loading ? (
                        <div className="text-center my-3">
                          <Spinner animation="border" variant="primary" />
                        </div>
                      ) : (
                        "Data is not available"
                      )}
                    />
                    <Card.Footer>
                      <Row>
                        <Col
                          xs={12}
                          md={6}
                          className="d-flex align-items-center py-1"
                        ></Col>
                        <Col
                          xs={12}
                          md={6}
                          className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                        >
                          {entries.length > 8 && (
                            <Paginator.PaginationListStandalone
                              {...paginationProps}
                            />
                          )}
                        </Col>
                      </Row>
                    </Card.Footer>
                  </div>
                </Card>
              )}
            </Paginator.PaginationProvider>
          )}
        </ToolkitProvider>
      ) : viewMode === 'BOM' ? (
        <Card>
          <div className="p-3 d-flex justify-content-between align-items-center border-bottom">
            <h5 className="head m-0" style={{ fontSize: '1.1rem' }}>
              {isBomEditable ? 'Edit ' : ''}BOM Components {selectedQuoteId ? `- ${selectedQuoteId}` : ''}
              {isBomEditable && (
                <span style={{ fontSize: "14px", fontWeight: "normal", marginLeft: "10px", color: "#6c757d" }}>
                  (Click on any cell below to edit its value)
                </span>
              )}
            </h5>
            <Button variant="outline-primary" size="sm" onClick={() => setViewMode('QUOTES')}>
              <FontAwesomeIcon icon={faArrowLeft} className="me-2" /> Back
            </Button>
          </div>
          <Card.Body>
            {bomLoading ? (
              <div className="text-center p-4">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <div className="table-responsive" style={{ maxHeight: "70vh", overflowY: "auto", overflowX: "auto" }}>
                <BootstrapTable
                  keyField="id"
                  data={bomComponents}
                  columns={bomColumns}
                  hover
                  striped
                  classes="table-flush dataTable-table table-sm mb-4 sales-custom-table"
                  bodyClasses="align-middle"
                  headerClasses="header-class"
                  {...(isBomEditable ? { 
                    cellEdit: cellEditFactory({ 
                      mode: 'click', 
                      blurToSave: true,
                      afterSaveCell: async (oldValue, newValue, row, column) => {
                        if (oldValue === newValue) return;
                        try {
                          const payload = {
                            ...row,
                            pkBomComponentId: row.pkBomComponentId || row.pkComponentId || (row.id !== 0 && row.id !== undefined ? row.id : null),
                            quoteID: selectedQuoteId,
                          };
                          await productService.updateBomComponent(payload);
                          swal("Success", "Component updated successfully!", "success");
                        } catch (error) {
                          console.error("Error updating BOM component:", error);
                          swal("Error", "Failed to update component", "error");
                        }
                      }
                    }) 
                  } : {})}
                  headerClasses="header-class text-nowrap"
                  noDataIndication="No BOM Components Found"
                  classes="table-flush dataTable-table text-nowrap table-sm mb-4"
                  bodyClasses="text-nowrap align-middle"
                />
              </div>
            )}
          </Card.Body>
        </Card>
      ) : null}

      <Modal show={showQueryModal} onHide={() => setShowQueryModal(false)} centered className="query-raise-modal">
        <Modal.Header closeButton className="query-raise-header">
          <Modal.Title className="query-raise-title"> {viewOnlyHistory ? "Query History" : "Raise a query"} </Modal.Title>
        </Modal.Header>
        <Modal.Body className="query-raise-body">
          {renderQueryHistory()}
          {!currentUserRole.toUpperCase().includes("SALES") && !viewOnlyHistory ? (
            <Form>
              <Form.Group className="mb-3">
                <Form.Label className="query-raise-label">Enter Query</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  placeholder="Enter your query"
                  value={queryData.query}
                  onChange={(e) => setQueryData({ ...queryData, query: e.target.value })}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="query-raise-label">Assign To</Form.Label>
                <Form.Select
                  value={queryData.queryAsignTo}
                  onChange={(e) => setQueryData({ ...queryData, queryAsignTo: e.target.value })}
                >
                  <option value="">Select Role</option>
                  {getAssigneeOptions().map((opt, idx) => (
                    <option key={idx} value={opt.value}>{opt.label}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
          ) : null}
        </Modal.Body>
        {!currentUserRole.toUpperCase().includes("SALES") && !viewOnlyHistory && (
          <Modal.Footer className="query-raise-footer">
            <Button variant="primary" onClick={handleQuerySubmit} className="query-raise-submit-btn">
              Submit Query
            </Button>
          </Modal.Footer>
        )}
      </Modal>

      <Modal show={showRespondModal} onHide={() => setShowRespondModal(false)} centered className="query-raise-modal">
        <Modal.Header closeButton className="query-raise-header">
          <Modal.Title className="query-raise-title"> Respond to Query </Modal.Title>
        </Modal.Header>
        <Modal.Body className="query-raise-body">
          {renderQueryHistory()}
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="query-raise-label">Your Response</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter your response"
                value={respondData.response}
                onChange={(e) => setRespondData({ ...respondData, response: e.target.value })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="query-raise-footer">
          <Button variant="primary" onClick={handleRespondSubmit} className="query-raise-submit-btn">
            Submit Response
          </Button>
        </Modal.Footer>
      </Modal>

      {viewMode === 'APPROVAL' && (
        <Card>
          <div className="p-3 d-flex justify-content-between align-items-center border-bottom">
            <h5 className="head m-0" style={{ fontSize: '1.1rem' }}>{approvalQuoteStatus && approvalQuoteStatus.toLowerCase() === 'approved' ? 'Approved' : approvalQuoteStatus && approvalQuoteStatus.toLowerCase() === 'declined' ? 'Declined' : 'Submit For Approval'} {approvalQuoteId ? `- ${approvalQuoteId}` : ''}</h5>
            <Button variant="outline-primary" size="sm" onClick={() => setViewMode('QUOTES')}>
              <FontAwesomeIcon icon={faArrowLeft} className="me-2" /> Back
            </Button>
          </div>
          <Card.Body style={{ paddingTop: '15px', paddingBottom: '20px', maxHeight: '75vh', overflowY: 'auto' }}>

            {selectedQuoteDetails && (
              <div className="mb-4 p-3 bg-light rounded" style={{ border: '1px solid #dee2e6' }}>
                <Row>
                  <Col md={4} className="mb-2"><strong>Type:</strong> {selectedQuoteDetails.type || "N/A"}</Col>
                  <Col md={4} className="mb-2"><strong>Model:</strong> {selectedQuoteDetails.modelNumber || "N/A"}</Col>
                  <Col md={4} className="mb-2"><strong>DU Type:</strong> {selectedQuoteDetails.duType || "N/A"}</Col>
                  <Col md={4} className="mb-2"><strong>Flow Rate:</strong> {selectedQuoteDetails.flowRate || "N/A"}</Col>
                  <Col md={4} className="mb-2"><strong>VRS:</strong> {selectedQuoteDetails.vrs || "N/A"}</Col>
                  <Col md={4} className="mb-2"><strong>DU Config:</strong> {selectedQuoteDetails.duConfiguration || "N/A"}</Col>
                </Row>
              </div>
            )}

            <Form>
              {[
                {
                  id: 'sales',
                  isCurrent: currentUserRole.toUpperCase().includes("SALES"),
                  content: (
                    <div className={`p-3 mb-4 rounded shadow-sm ${currentUserRole.toUpperCase().includes("SALES") ? 'bg-white' : 'bg-light'}`} style={{ border: '1px solid #dee2e6', borderLeft: currentUserRole.toUpperCase().includes("SALES") ? '4px solid #198754' : '1px solid #dee2e6' }}>
                      <h6 className="mb-3 text-primary" style={{ fontSize: '0.95rem', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 'bold' }}>Sales Department</h6>
                      <Row>
                        <Col md={3}>
                          <Form.Group className="mb-2">
                            <Form.Label style={{ fontSize: '0.88rem', marginBottom: '2px' }}>Target Price</Form.Label>
                            <InputGroup size="sm">
                              {selectedQuoteDetails?.currency && (
                                <InputGroup.Text style={{ borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' }}>
                                  {selectedQuoteDetails.currency}
                                </InputGroup.Text>
                              )}
                              <Form.Control
                                type="text"
                                style={{ borderTopRightRadius: '8px', borderBottomRightRadius: '8px', borderRadius: selectedQuoteDetails?.currency ? '0 8px 8px 0' : '8px' }}
                                placeholder={currentUserRole.toUpperCase().includes("SALES") ? "Enter target price" : ""}
                                value={approvalData.targetPrice}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (/^\d*\.?\d*$/.test(val)) {
                                    setApprovalData({ ...approvalData, targetPrice: val });
                                  }
                                }}
                                disabled={isApprovedView || !currentUserRole.toUpperCase().includes("SALES")}
                              />
                            </InputGroup>
                          </Form.Group>
                        </Col>

                        <Col md={3}>
                          <Form.Group className="mb-2">
                            <Form.Label style={{ fontSize: '0.88rem', marginBottom: '2px' }}>Win Probability (%)</Form.Label>
                            <Form.Control
                              type="text"
                              size="sm"
                              style={{ borderRadius: '8px' }}
                              placeholder={currentUserRole.toUpperCase().includes("SALES") ? "Enter win probability" : ""}
                              value={approvalData.winProbability}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val === "" || (/^\d*\.?\d*$/.test(val) && Number(val) <= 100)) {
                                  setApprovalData({ ...approvalData, winProbability: val });
                                }
                              }}
                              disabled={isApprovedView || !currentUserRole.toUpperCase().includes("SALES")}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      {currentUserRole.toUpperCase().includes("SALES") && !isApprovedView && (
                        <div className="d-flex justify-content-end mt-3 pt-3 border-top">
                          <Button variant="success" size="sm" onClick={confirmSubmitForApproval} disabled={!isApprovalFormValid()}>Submit for approval</Button>
                        </div>
                      )}
                    </div>
                  )
                },
                {
                  id: 'rnd',
                  isCurrent: currentUserRole === "RND_REVIEWER",
                  content: (
                    <div className={`p-3 mb-4 rounded shadow-sm ${currentUserRole === "RND_REVIEWER" ? 'bg-white' : 'bg-light'}`} style={{ border: '1px solid #dee2e6', borderLeft: currentUserRole === "RND_REVIEWER" ? '4px solid #198754' : '1px solid #dee2e6' }}>
                      <h6 className="mb-3 text-primary" style={{ fontSize: '0.95rem', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 'bold' }}>R&D Department</h6>
                      <Row>
                        <Col md={2}>
                          <Form.Group className="mb-2">
                            <Form.Label style={{ fontSize: '0.88rem', marginBottom: '2px' }}>BOM Readiness (%)</Form.Label>
                            <Form.Control
                              type="text"
                              size="sm"
                              style={{ borderRadius: '8px' }}
                              placeholder={currentUserRole === "RND_REVIEWER" ? "Enter BOM readiness" : ""}
                              value={approvalData.bomReadiness}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val === "" || (/^\d*\.?\d*$/.test(val) && Number(val) <= 100)) {
                                  setApprovalData({ ...approvalData, bomReadiness: val });
                                }
                              }}
                              disabled={isApprovedView || currentUserRole !== "RND_REVIEWER"}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={5}>
                          <Form.Group className="mb-2">
                            <Form.Label style={{ fontSize: '0.88rem', marginBottom: '2px' }}>New Certifications</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={2}
                              size="sm"
                              style={{ borderRadius: '8px' }}
                              placeholder={currentUserRole === "RND_REVIEWER" ? "Enter new certifications" : ""}
                              value={approvalData.newCertifications}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val.length <= 150) {
                                  setApprovalData({ ...approvalData, newCertifications: val });
                                }
                              }}
                              disabled={isApprovedView || currentUserRole !== "RND_REVIEWER"}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={5}>
                          <Form.Group className="mb-2">
                            <Form.Label style={{ fontSize: '0.88rem', marginBottom: '2px' }}>Additional Customization</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={2}
                              size="sm"
                              style={{ borderRadius: '8px' }}
                              placeholder={currentUserRole === "RND_REVIEWER" ? "Enter additional customization" : ""}
                              value={approvalData.additionalCustomization}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val.length <= 150) {
                                  setApprovalData({ ...approvalData, additionalCustomization: val });
                                }
                              }}
                              disabled={isApprovedView || currentUserRole !== "RND_REVIEWER"}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      {currentUserRole === "RND_REVIEWER" && !isApprovedView && (
                        <div className="d-flex justify-content-end mt-3 pt-3 border-top">
                          <Button variant="success" size="sm" onClick={confirmSubmitForApproval} disabled={!isApprovalFormValid()}>Submit for approval</Button>
                        </div>
                      )}
                    </div>
                  )
                },
                {
                  id: 'procurement',
                  isCurrent: currentUserRole === "PROCUREMENT_REVIEWER",
                  content: (
                    <div className={`p-3 mb-4 rounded shadow-sm ${currentUserRole === "PROCUREMENT_REVIEWER" ? 'bg-white' : 'bg-light'}`} style={{ border: '1px solid #dee2e6', borderLeft: currentUserRole === "PROCUREMENT_REVIEWER" ? '4px solid #198754' : '1px solid #dee2e6' }}>
                      <h6 className="mb-3 text-primary" style={{ fontSize: '0.95rem', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 'bold' }}>Procurement Department</h6>
                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-2">
                            <Form.Label style={{ fontSize: '0.88rem', marginBottom: '2px' }}>Lead Time (Weeks)</Form.Label>
                            <Form.Select
                              size="sm"
                              style={{ borderRadius: '8px' }}
                              value={approvalData.leadTime}
                              onChange={(e) => setApprovalData({ ...approvalData, leadTime: e.target.value })}
                              disabled={isApprovedView || currentUserRole !== "PROCUREMENT_REVIEWER"}
                            >
                              <option value="">Select Lead Time</option>
                              <option value="4 weeks">4 weeks</option>
                              <option value="8 weeks">8 weeks</option>
                              <option value="12 to 16 weeks">12 to 16 weeks</option>
                              <option value="16 to 20 weeks">16 to 20 weeks</option>
                              <option value="20 + weeks">20 + weeks</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>
                        <Col md={3}>
                          <Form.Group className="mb-2">
                            <Form.Label style={{ fontSize: '0.88rem', marginBottom: '2px' }}>Inventory Availability (%)</Form.Label>
                            <Form.Control
                              type="text"
                              size="sm"
                              style={{ borderRadius: '8px' }}
                              placeholder={currentUserRole === "PROCUREMENT_REVIEWER" ? "Enter inventory availability" : ""}
                              value={approvalData.inventoryAvailability}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val === "" || (/^\d*\.?\d*$/.test(val) && Number(val) <= 100)) {
                                  setApprovalData({ ...approvalData, inventoryAvailability: val });
                                }
                              }}
                              disabled={isApprovedView || currentUserRole !== "PROCUREMENT_REVIEWER"}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      {currentUserRole === "PROCUREMENT_REVIEWER" && !isApprovedView && (
                        <div className="d-flex justify-content-end mt-3 pt-3 border-top">
                          <Button variant="success" size="sm" onClick={confirmSubmitForApproval} disabled={!isApprovalFormValid()}>Submit for approval</Button>
                        </div>
                      )}
                    </div>
                  )
                },
                {
                  id: 'finance',
                  isCurrent: currentUserRole === "FINANCE_REVIEWER",
                  content: (
                    <div className={`p-3 mb-4 rounded shadow-sm ${currentUserRole === "FINANCE_REVIEWER" ? 'bg-white' : 'bg-light'}`} style={{ border: '1px solid #dee2e6', borderLeft: currentUserRole === "FINANCE_REVIEWER" ? '4px solid #198754' : '1px solid #dee2e6' }}>
                      <h6 className="mb-3 text-primary" style={{ fontSize: '0.95rem', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 'bold' }}>Finance Department</h6>
                      <Row>
                        <Col md={3}>
                          <Form.Group className="mb-2">
                            <Form.Label style={{ fontSize: '0.88rem', marginBottom: '2px' }}>P/L (Amount / %)</Form.Label>
                            <Form.Control
                              type="text"
                              size="sm"
                              style={{ borderRadius: '8px' }}
                              placeholder={currentUserRole === "FINANCE_REVIEWER" ? "Enter P/L" : ""}
                              value={approvalData.pl}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val.length <= 150) {
                                  setApprovalData({ ...approvalData, pl: val });
                                }
                              }}
                              disabled={isApprovedView || currentUserRole !== "FINANCE_REVIEWER"}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-2">
                            <Form.Label style={{ fontSize: '0.88rem', marginBottom: '2px' }}>CC Plan</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={2}
                              size="sm"
                              style={{ borderRadius: '8px' }}
                              placeholder={currentUserRole === "FINANCE_REVIEWER" ? "Enter CC plan" : ""}
                              value={approvalData.ccPlan}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val.length <= 150) {
                                  setApprovalData({ ...approvalData, ccPlan: val });
                                }
                              }}
                              disabled={isApprovedView || currentUserRole !== "FINANCE_REVIEWER"}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      {currentUserRole === "FINANCE_REVIEWER" && !isApprovedView && (
                        <div className="d-flex justify-content-end mt-3 pt-3 border-top">
                          <Button variant="success" size="sm" onClick={confirmSubmitForApproval} disabled={!isApprovalFormValid()}>Submit for approval</Button>
                        </div>
                      )}
                    </div>
                  )
                },
                {
                  id: 'production',
                  isCurrent: currentUserRole === "PRODUCTION_REVIEWER",
                  content: (
                    <div className={`p-3 mb-4 rounded shadow-sm ${currentUserRole === "PRODUCTION_REVIEWER" ? 'bg-white' : 'bg-light'}`} style={{ border: '1px solid #dee2e6', borderLeft: currentUserRole === "PRODUCTION_REVIEWER" ? '4px solid #198754' : '1px solid #dee2e6' }}>
                      <h6 className="mb-3 text-primary" style={{ fontSize: '0.95rem', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 'bold' }}>Production Department</h6>
                      <Row>
                        <Col md={3}>
                          <Form.Group className="mb-2">
                            <Form.Label style={{ fontSize: '0.88rem', marginBottom: '2px' }}>Resource Availability (%)</Form.Label>
                            <Form.Control
                              type="text"
                              size="sm"
                              style={{ borderRadius: '8px' }}
                              placeholder={currentUserRole === "PRODUCTION_REVIEWER" ? "Enter resource availability" : ""}
                              value={approvalData.resourceAvailability}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val === "" || (/^\d*\.?\d*$/.test(val) && Number(val) <= 100)) {
                                  setApprovalData({ ...approvalData, resourceAvailability: val });
                                }
                              }}
                              disabled={isApprovedView || currentUserRole !== "PRODUCTION_REVIEWER"}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-2">
                            <Form.Label style={{ fontSize: '0.88rem', marginBottom: '2px' }}>Additional Inputs</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={2}
                              size="sm"
                              style={{ borderRadius: '8px' }}
                              placeholder={currentUserRole === "PRODUCTION_REVIEWER" ? "Enter additional inputs" : ""}
                              value={approvalData.additionalInputs}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val.length <= 150) {
                                  setApprovalData({ ...approvalData, additionalInputs: val });
                                }
                              }}
                              disabled={isApprovedView || currentUserRole !== "PRODUCTION_REVIEWER"}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      {currentUserRole === "PRODUCTION_REVIEWER" && !isApprovedView && (
                        <div className="d-flex justify-content-end mt-3 pt-3 border-top">
                          <Button variant="success" size="sm" onClick={confirmSubmitForApproval} disabled={!isApprovalFormValid()}>Submit for approval</Button>
                        </div>
                      )}
                    </div>
                  )
                },
                {
                  id: 'slt',
                  isCurrent: currentUserRole === "SLT_REVIEWER",
                  content: (
                    <div className={`p-3 mb-4 rounded shadow-sm ${currentUserRole === "SLT_REVIEWER" ? 'bg-white' : 'bg-light'}`} style={{ border: '1px solid #dee2e6', borderLeft: currentUserRole === "SLT_REVIEWER" ? '4px solid #198754' : '1px solid #dee2e6' }}>
                      <h6 className="mb-3 text-primary" style={{ fontSize: '0.95rem', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 'bold' }}>SLT</h6>
                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-2">
                            <Form.Label style={{ fontSize: '0.88rem', marginBottom: '2px' }}>Approval Terms & Conditions</Form.Label>
                            <Form.Control
                              as="textarea"
                              size="sm"
                              style={{ borderRadius: '8px' }}
                              rows={2}
                              placeholder={currentUserRole === "SLT_REVIEWER" ? "Enter approval terms & conditions" : ""}
                              value={approvalData.approvalTerms}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val.length <= 150) {
                                  setApprovalData({ ...approvalData, approvalTerms: val });
                                }
                              }}
                              disabled={isApprovedView || currentUserRole !== "SLT_REVIEWER"}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      {currentUserRole === "SLT_REVIEWER" && !isApprovedView && (
                        <div className="d-flex justify-content-end mt-3 pt-3 border-top" style={{ gap: '10px' }}>
                          <Button variant="danger" size="sm" onClick={() => confirmSLTAction('decline')} disabled={!isApprovalFormValid()}>Decline</Button>
                          <Button variant="success" size="sm" onClick={() => confirmSLTAction('approve')} disabled={!isApprovalFormValid()}>Approve</Button>
                        </div>
                      )}
                    </div>
                  )
                }
              ]
                .sort((a, b) => (b.isCurrent ? 1 : 0) - (a.isCurrent ? 1 : 0))
                .map(section => (
                  <React.Fragment key={section.id}>
                    {section.content}
                  </React.Fragment>
                ))}
            </Form>
          </Card.Body>
        </Card>
      )}

    </div>
  );
};

export default Draft;